// extracted by mini-css-extract-plugin
export default {"menu":"Profile_menu__S3Zdh","section":"Profile_section__UZbGf","sectionTitle":"Profile_sectionTitle__YOJcz","menuItem":"Profile_menuItem__AIQnh","chevron":"Profile_chevron__0Kilb"};